import { WorkflowTemplate } from "./types";

export const workflows: WorkflowTemplate[] = [
  {
    id: "1",
    name: "Welcome Email Automation",
    description:
      "Automatically send a personalized welcome email to new subscribers.",
    category: "Email",
    tags: ["Onboarding", "Automation"],
    usageCount: 5234,
    rating: 4.9,
    createdAt: "2026-01-01",
    updatedAt: "2026-02-20",
    isVerified: true,
    isRecommended: true,
  },
  {
    id: "2",
    name: "Abandoned Cart Recovery",
    description:
      "Recover lost sales by sending reminder emails for abandoned carts.",
    category: "Email",
    tags: ["E-commerce", "Sales"],
    usageCount: 4821,
    rating: 4.8,
    createdAt: "2026-01-05",
    updatedAt: "2026-02-18",
    isRecommended: true,
  },
  {
    id: "3",
    name: "Weekly Newsletter Campaign",
    description: "Send automated weekly newsletters to your subscribers.",
    category: "Email",
    tags: ["Newsletter", "Engagement"],
    usageCount: 3960,
    rating: 4.7,
    createdAt: "2026-01-10",
    updatedAt: "2026-02-15",
  },
  {
    id: "4",
    name: "Re-Engagement Campaign",
    description: "Win back inactive subscribers with targeted email sequences.",
    category: "Email",
    tags: ["Retention", "Engagement"],
    usageCount: 2875,
    rating: 4.6,
    createdAt: "2026-01-12",
    updatedAt: "2026-02-16",
  },
  {
    id: "5",
    name: "Product Launch Announcement",
    description: "Notify subscribers about new product launches.",
    category: "Email",
    tags: ["Product", "Marketing"],
    usageCount: 3421,
    rating: 4.8,
    createdAt: "2026-01-14",
    updatedAt: "2026-02-19",
    isVerified: true,
  },
  {
    id: "6",
    name: "Customer Feedback Request",
    description: "Request feedback automatically after purchase.",
    category: "Email",
    tags: ["Feedback", "Customer Experience"],
    usageCount: 2140,
    rating: 4.5,
    createdAt: "2026-01-16",
    updatedAt: "2026-02-17",
  },
  {
    id: "7",
    name: "Birthday Email Automation",
    description: "Send automated birthday wishes and discount coupons.",
    category: "Email",
    tags: ["Personalization", "Offers"],
    usageCount: 1850,
    rating: 4.4,
    createdAt: "2026-01-18",
    updatedAt: "2026-02-18",
  },
  {
    id: "8",
    name: "Lead Magnet Delivery",
    description: "Automatically send eBooks or PDFs after signup.",
    category: "Email",
    tags: ["Lead Generation", "Content"],
    usageCount: 2670,
    rating: 4.7,
    createdAt: "2026-01-20",
    updatedAt: "2026-02-19",
  },
  {
    id: "9",
    name: "Event Reminder Series",
    description: "Send reminder emails before scheduled events or webinars.",
    category: "Email",
    tags: ["Events", "Webinar"],
    usageCount: 1980,
    rating: 4.6,
    createdAt: "2026-01-22",
    updatedAt: "2026-02-17",
  },
  {
    id: "10",
    name: "Subscription Renewal Reminder",
    description: "Automatically notify users about upcoming renewals.",
    category: "Email",
    tags: ["Subscription", "Retention"],
    usageCount: 2215,
    rating: 4.7,
    createdAt: "2026-01-24",
    updatedAt: "2026-02-19",
  },

  // Duplicate pattern variations to reach ~30

  {
    id: `15`,
    name: `Promotional Campaign #15`,
    description:
      "Send promotional offers and seasonal discounts automatically.",
    category: "Email",
    tags: ["Promotion", "Sales"],
    usageCount: 1500,
    rating: 4.3,
    createdAt: "2026-01-25",
    updatedAt: "2026-02-20",
  },
];
